define('presentation/settings/callQueues/viewModels/callQueuePoolViewModel',[
    'businessServices/state/modelStateObserver',
    'constants/liveReceptionistQueueHoldSettingConstants',
    'presentation/common/routeToModal/strategies/callQueuePoolStrategy',
    'presentation/common/routeToModal/viewModels/routeToViewModel',
    'presentation/settings/callQueues/validators/callQueuePoolViewModelValidator'
], function () {
    return function (parent, originalPool) {
        const self = this;

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');
        const RouteToStrategyConstructor = require('presentation/common/routeToModal/strategies/callQueuePoolStrategy');
        const RouteToViewModelConstructor = require('presentation/common/routeToModal/viewModels/routeToViewModel');

        const _holdSettingConstants = require('constants/liveReceptionistQueueHoldSettingConstants');
        const _i18n = require('i18next');
        const _originalPool = originalPool;
        const _parent = parent;

        const DEFAULT_MAX_CALLERS_IN_QUEUE = 25;
        const DEFAULT_MAX_WAIT_SECONDS = 300;
        const DEFAULT_MAX_CONCURRENT_DESTINATION_CALLS = 10;

        // What a schedule range starts a new destination on: the route-to editor reads this as
        // nothing picked yet and shows its please-select state.
        const NO_DESTINATION_ROUTE_TO_TYPE = 'autoAttendant';
        const NO_DESTINATION_ROUTE_TO_DATA = {autoAttendantId: "[None]"};

        self.accountCallQueuePoolId = null;
        self.modelStateObserver = null;
        self.routeToOptions = {};
        self.routeToStrategy = new RouteToStrategyConstructor();
        self.validator = null;

        // Fill order, assigned from the pool's position in the list so that the order shown is the
        // order callers are placed in.
        self.sequence = ko.observable(0).extend({observeState: true});

        self.poolName = ko.observable('').extend({observeState: true});
        self.maxCallersInQueue = ko.observable(DEFAULT_MAX_CALLERS_IN_QUEUE).extend({observeState: true});
        self.maxWaitSeconds = ko.observable(DEFAULT_MAX_WAIT_SECONDS).extend({observeState: true});
        self.maxConcurrentDestinationCalls = ko.observable(DEFAULT_MAX_CONCURRENT_DESTINATION_CALLS).extend({observeState: true});
        self.selectedQueueHoldSetting = ko.observable(_holdSettingConstants.HoldMusic).extend({observeState: true});
        self.routeToViewModel = ko.observable().extend({observeState: true});

        // Ringing is a hold treatment the queue accepts, but only hold music is offered here for
        // now. The dropdown stays so the field is already in place when the other one is turned on.
        self.availableQueueHoldSettings = [
            {
                id: _holdSettingConstants.HoldMusic,
                text: _i18n.t('addCallQueue:playHoldMusic')
            }
        ];

        self.placeholderMessage = _i18n.t('addCallQueue:poolPlaceholderMessage');

        self.legendPoolName = ko.pureComputed(() => {
            const name = self.poolName();
            if (name) {
                return name;
            }

            return _i18n.t('addCallQueue:unnamedPool_sequence', {sequence: self.sequence()});
        });

        self.canDisplayValidation = ko.observable(false);
        self.isRoutingRuleValid = ko.observable();

        self.shouldPreventDeletion = ko.computed(() => !_parent.canDeletePool());

        self.deleteToolTip = ko.computed(() => {
            return self.shouldPreventDeletion() ? _i18n.t('addCallQueue:lastItemTooltip') : '';
        });

        self.deleteMe = () => {
            _parent.deletePool(self);
        };

        self.getPool = () => {
            return {
                accountCallQueuePoolId: self.accountCallQueuePoolId,
                name: self.poolName().trim(),
                priority: self.sequence(),
                destinationRoutingRule: self.routeToStrategy.buildRoutingRule(self.routeToViewModel()),
                maxCallersInQueue: parseInt(self.maxCallersInQueue(), 10),
                maxWaitSeconds: parseInt(self.maxWaitSeconds(), 10),
                maxConcurrentDestinationCalls: parseInt(self.maxConcurrentDestinationCalls(), 10),
                queueHoldSetting: parseInt(self.selectedQueueHoldSetting(), 10)
            };
        };

        const _validateRouteToViewModelCallback = () => {
            self.canDisplayValidation(false);
            return true;
        };

        // Every destination a schedule range can route to, for the same reason: releasing a caller
        // is an ordinary route, and the queue hands the callflow over untouched. Sub menus are the
        // exception, as they belong to an auto attendant's key presses rather than standing alone.
        const _buildRouteToViewModel = (routeToType, routeToData) => {
            const routeToViewModel = new RouteToViewModelConstructor(routeToType, routeToData, _validateRouteToViewModelCallback, {
                subMenu: {enabled: false}
            });
            routeToViewModel.routeToStrategy = self.routeToStrategy;
            routeToViewModel.showAnswerTimeoutOptions(false);
            routeToViewModel.routeTitle(_i18n.t('addCallQueue:routeToTitle'));
            routeToViewModel.showRouteToTitle(true);
            routeToViewModel.showRouteToOptions(true);
            routeToViewModel.parentViewModel(_parent);
            routeToViewModel.modelStateObserver.commitData();

            return routeToViewModel;
        };

        const _initialize = () => {
            if (_originalPool) {
                self.accountCallQueuePoolId = _originalPool.accountCallQueuePoolId;
                self.poolName(_originalPool.name);
                self.sequence(_originalPool.priority);
                self.maxCallersInQueue(_originalPool.maxCallersInQueue);
                self.maxWaitSeconds(_originalPool.maxWaitSeconds);
                self.maxConcurrentDestinationCalls(_originalPool.maxConcurrentDestinationCalls);
                self.selectedQueueHoldSetting(_originalPool.queueHoldSetting.toString());
                self.routeToViewModel(_buildRouteToViewModel('routingRule', _originalPool.destinationRoutingRule));
            } else {
                self.routeToViewModel(_buildRouteToViewModel(NO_DESTINATION_ROUTE_TO_TYPE, NO_DESTINATION_ROUTE_TO_DATA));
            }

            const ValidatorConstructor = require('presentation/settings/callQueues/validators/callQueuePoolViewModelValidator');
            self.validator = new ValidatorConstructor();
            self.validator.registerViewModel(self, _parent.pools);

            self.modelStateObserver = new ModelStateObserverConstructor(self, true, self.routeToViewModel().modelStateObserver);
            self.modelStateObserver.commitData();
        };

        _initialize();
    };
});

